import { useTheme } from "@/utils/theme-context";
import Button from "./UI/Button";
import { useAuth } from "@/utils/auth-context";

import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "@/firebase/firebaseConfig";
import { useEffect, useState } from "react";
import UpdatePassword from "./UpdatePassword";

const AccountInfo = () => {
  const { theme } = useTheme();
  const { email } = useAuth();
  const [name, setName] = useState("");
  const [birthYear, setBirthYear] = useState("");
  const [location, setLocation] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const loadUserData = async () => {
      const user = auth.currentUser;
      if (user) {
        try {
          const docRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const userData = docSnap.data();
            setName(userData.name);
            setBirthYear(userData.birthYear);

            setLocation(userData.location);
          } else {
            console.log("Документ не найден!");
          }
        } catch (error) {
          console.error("Ошибка при загрузке данных пользователя:", error);
        }
      }
    };

    loadUserData();
  }, []);

  const saveUserData = async () => {
    try {
      const user = auth.currentUser;
      if (!user) throw new Error("Пользователь не аутентифицирован");

      const updatedData = { name, birthYear, location };
      await setDoc(doc(db, "users", user.uid), updatedData, { merge: true });
    } catch (error) {
      throw new Error(
        error.message || "Ошибка при сохранении данных пользователя",
      );
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!name || !birthYear || !location) {
      setErrorMessage("Пожалуйста, заполните все поля.");
      return;
    }

    setLoading(true);
    try {
      await saveUserData();
      setSuccessMessage("Данные пользователя успешно сохранены!");
      setErrorMessage("");
    } catch (error) {
      setErrorMessage(error.message || "Ошибка сохранения данных.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="accountInfo">
      <form className="accountInfo-body">
        <div className="accountInfo-body-item">
          <label htmlFor="name">Имя</label>
          <input
            className={`input input--${theme}`}
            type="text"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="accountInfo-body-item">
          <label htmlFor="email">Email</label>
          <input
            className={`accountInfo-body-item__email input input--${theme}`}
            type="email"
            name="email"
            disabled
            value={email}
          />
        </div>

        <div className="accountInfo-body-item">
          <label htmlFor="birthYear">Год рождения</label>
          <input
            className={`input input--${theme}`}
            type="date"
            name="birthYear"
            lang="ru"
            value={birthYear}
            onChange={(e) => setBirthYear(e.target.value)}
          />
        </div>

        <div className="accountInfo-body-item">
          <label htmlFor="location">
            В какой стране вы сейчас проживаете постоянно?
          </label>
          <input
            className={`input input--${theme}`}
            type="text"
            name="location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />
        </div>

        {loading ? (
          <Button
            title="Сохранить"
            color="black"
            disabled
            onClick={handleSave}
          />
        ) : (
          <Button title="Сохранить" color="blue" onClick={handleSave} />
        )}
        {errorMessage && (
          <p className="authentication-box__error"> {errorMessage} </p>
        )}
        {successMessage && (
          <p className="authentication-box__success"> {successMessage} </p>
        )}
      </form>

      <hr className="line" />

      <UpdatePassword />
    </div>
  );
};

export default AccountInfo;
